import { afterNextRender, Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MessageService } from '@pct-ng/feature-message-material';
import { Store } from '@ngxs/store';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { RemoveSplashAction } from '@pct-ng/feature-app-layout-state';
import { environment } from '@szte-griffin/environment';

@Component({
  imports: [RouterModule],
  selector: 'mecap-root',
  templateUrl: './app.component.html',
  host: {
    class: 'block h-full',
  },
})
export class AppComponent {
  constructor() {
    // Start service
    inject(MessageService);
    const store = inject(Store);
    inject(MatIconRegistry).addSvgIconSet(
      inject(DomSanitizer).bypassSecurityTrustResourceUrl('./pct.symbol.svg'),
    );
    /**
     * kesleltetve vesszuk le a takaro kepernyot, hogy tuti minden megjelenjen addigra,
     * meresek alapjan settimeout nelkul belepett usernel fast 4g -nel is volt feher kepernyo
     */
    afterNextRender(() =>
      setTimeout(
        () => store.dispatch(new RemoveSplashAction()),
        environment.isAngularDevMode ? 0 : 1000,
      ),
    );
  }
}
